import { DocumentTypeEnum } from "@finway-group/shared/lib/models"
import { Upload } from "antd"
import { UploadFile } from "antd/es/upload/interface"
import React, { useRef, useState } from "react"
import UploadFileDraggerContent, { UploadFileDraggerContentInterface } from "./UploadFileDraggerContent"

interface UploadFileDraggerInterface extends UploadFileDraggerContentInterface {
    doFileUpload: (files: File[], kind: DocumentTypeEnum) => Promise<void>
    documentType: DocumentTypeEnum
}

const { Dragger } = Upload

const UploadFilesDragger: React.FC<UploadFileDraggerInterface> = ({ doFileUpload, documentType, label, isUploading }) => {
    const [fileList, setFileList] = useState([] as UploadFile[])
    const onChangeCallCount = useRef(0) // have to useRef because useState won't work w/ tight onChange of antd between invocations

    return (
        <Dragger
            multiple={true}
            showUploadList={false}
            accept={".jpg,.jpeg,.png,.pdf"}
            disabled={isUploading}
            /**
             * TODO: use onDrop event instead after upgrading antd
             * see: https://ant.design/components/upload/#API
             */
            // handle multi file upload-hack
            fileList={fileList}
            beforeUpload={() => false} // prevent automatic upload of single files
            onChange={({ fileList }) => {
                setFileList(fileList.filter((file) => file.status !== "error"))
                // if the number of times this method was called EQUALS the number of files dragged into the field execute the upload
                if (++onChangeCallCount.current === fileList.length) {
                    doFileUpload(
                        fileList.map((file) => file.originFileObj as File),
                        documentType
                    ).finally(() => {
                        // after upload reset file list and method call-count
                        setFileList([])
                        onChangeCallCount.current = 0
                    })
                }
            }}
        >
            <UploadFileDraggerContent label={label} isUploading={isUploading} />
        </Dragger>
    )
}

export default UploadFilesDragger
